import { useContext, useState } from "react";
import EncounterList from "./encounterList/EncounterList";
import { ShowContext } from "../../context/Context";
import {
  filterEncounterByConditionId,
  getConditionId,
  getMappedData,
} from "../../fetchData";
import "./encounterTimeline.css";
import ConditionTimeline from "./conditionTimeline/ConditionTimeline";
import {
  getEncountersWithDiagnosis,
  isKeyPresentInData,
} from "../service/constants";
const EncounterTimeline = () => {
  const [active, setactive] = useState(false);
  const { wholeData } = useContext(ShowContext);
  console.log("patientId", wholeData);
  const isTimelinePresent = isKeyPresentInData("Condition", wholeData);
  const encounter = isKeyPresentInData("Encounter", wholeData);
  const [conditionKey, setconditionKey] = useState(null);
  if (!isTimelinePresent || !encounter) {
    return <h1>No Encounter timeline for the patient.</h1>;
  }

  const { objects } = wholeData?.find(
    (item) => item.resourceType === "Condition"
  );
  const { objects: encounterObjects } = wholeData?.find(
    (item) => item.resourceType === "Encounter"
  );
  const reqCond = getMappedData(objects);
  const mappedConditions = Array.from(reqCond).map(([key, value]) => {
    return {
      conditionType: key,
      objects: value,
    };
  });
  const id = getConditionId(conditionKey, mappedConditions);
  console.log(id);
  const reqEncounterObject = filterEncounterByConditionId(encounterObjects, id);
  const allEncounterConditions = getEncountersWithDiagnosis(
    mappedConditions,
    encounterObjects
  );
  console.log(allEncounterConditions);

  return (
    <section className="encounter_container">
      <div className="encounter__wrapper">
        <EncounterList
          setconditionKey={setconditionKey}
          conditionKey={conditionKey}
          mappedConditions={mappedConditions}
          active={active}
          setactive={setactive}
        />
        {reqEncounterObject && (
          <ConditionTimeline
            encounterData={
              active === true ? allEncounterConditions : reqEncounterObject
            }
            conditionKey={conditionKey?.toUpperCase()}
            active={active}
          />
        )}
      </div>
    </section>
  );
};

export default EncounterTimeline;
